import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';

import store from '@/state/store'

import App from './App.vue'

Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.component('apexchart', VueApexCharts)
Vue.use(require('vue-moment'))
Vue.use(require('vue-cookies'))

new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    user: {
      role: 'user',
      discord: {
        id: 'n/a',
        username: 'n/a',
        avatar: ''
      }
    }
  },
  methods: {
    fetchData () {
      if (this.$cookies.get('stashedSession')) {
        fetch(`/api/v1/user/@me`, {
          credentials: 'include'
        }).then(res => res.json()).then(res => {
          this.user = res
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  created () {
    this.fetchData()
  }
}).$mount('#app')